<template>
  <!--  打卡查询-->
  <div class="clock">
    <div class="clock_box">
      <el-card>
        <el-form :inline="true" label-width="120px" size="small" :model="searchData" ref="ruleForm">
          <el-row>
            <el-col :span="12">
              <el-form-item label="用户" prop="userInfoId">
                <el-select
                  placeholder="请选择"
                  v-model="searchData.userInfoId"
                  clearable
                  @change="userChange"
                >
                  <el-option
                    v-for="item in userInfo"
                    :key="item.id"
                    :label="item.nickName"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="内外勤" prop="isInside">
                <el-select placeholder="请选择" v-model="searchData.isInside" clearable>
                  <el-option
                    v-for="item in isInsides"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="打卡时间-起始" prop="createDateStart">
                <el-date-picker
                  v-model="searchData.createDateStart"
                  type="datetime"
                  placeholder="选择日期时间"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="打卡时间-结束" prop="createDateEnd">
                <el-date-picker
                  v-model="searchData.createDateEnd"
                  type="datetime"
                  placeholder="选择日期时间"
                ></el-date-picker>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="打卡类型" prop="recordType">
                <el-select placeholder="请选择" v-model="searchData.recordType" clearable>
                  <el-option
                    v-for="item in clockType"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-form-item>
              <el-button style="margin-left: 120px" type="primary" @click="clockSearch">查询</el-button>
              <el-button
                style="margin-left: 30px"
                type="primary"
                @click="clockLoad"
                icon="el-icon-download"
              >下载</el-button>
              <el-button style="margin-left: 30px" type="primary" @click="clockClear()">清空</el-button>
            </el-form-item>
          </el-row>
        </el-form>
      </el-card>
      <!-- 打卡列表 -->
      <el-card>
        <el-table
          align="center"
          border
          ref="multipleTable"
          style="width: 100%; flex: auto"
          tooltip-effect="light"
          :data="clockList"
          @selection-change="handleSelectionChange"
          :header-cell-style="getRowClass"
        >
          <el-table-column label="用户名字" prop="nickName" align="center" width="120px"></el-table-column>

          <el-table-column label="地址" prop="address" align="center" width="400px"></el-table-column>

          <el-table-column prop="createDate" label="打卡时间" align="center" width="200px"></el-table-column>

          <el-table-column prop="isInside" label="内外勤" align="center"></el-table-column>
          <el-table-column prop="recordType" label="打卡类型" align="center"></el-table-column>

          <el-table-column
            align="center"
            class-name="small-padding fixed-width"
            label="操作"
            width="400px"
          >
            <template slot-scope="{row}">
              <div class="done">
                <el-button type="primary" @click="clockDetail(row)" style="marginLeft:50px">详情</el-button>
                <el-button type="primary" @click="clockDel(row.id)" class="dels">删除</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-row style="width:auto;marginRight:50px;marginTop:20px;">
          <el-pagination
            :current-page="currentPage"
            :page-size="pagesize"
            :page-sizes="[5,10,15]"
            :total="totalCount"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
          ></el-pagination>
        </el-row>
      </el-card>

      <!-- 详情页面 -->
      <a-drawer
        title="考勤详情"
        :width="1000"
        :visible="visible"
        :body-style="{ paddingBottom: '80px' }"
        @close="onClose"
      >
        <Detail :Detaildata="detailData" />
      </a-drawer>
    </div>
    <!-- 删除弹出框 -->
    <a-modal :visible="delOpen" ok-text="确认" cancel-text="取消" @ok="handleOk" @cancel="handleCancel">
      <p>确定要删除吗？</p>
    </a-modal>
  </div>
</template>
<script>
import axios from "axios";
import Detail from "./detail";
import {baseURL} from '../../api/config'
export default {
  data() {
    return {
      visible: false,
      back: false, //开关
      delId: "", //删除id
      delOpen: false, //删除弹框
      currentPage: 1, //分页
      pagesize: 10, //分页
      pageNum: 1, //分页
      totalCount: 0, //分页
      //查询数据：
      searchData: {
        userInfoId: "", //用户 id
        createDateStart: "", //打卡时间-起始
        createDateEnd: "", //打卡时间-结束
        isInside: "", //内外勤:1 内勤，2 外勤
        recordType: "" //打卡类型：1：4g;2:wifi
      },
      clockList: [], //打卡列表
      userInfo: "", //用户数据
      userInfoIds: "", //选择查询用户id
      //打卡类型-下拉：;2:
      clockType: [
        {
          label: "4g",
          value: "1"
        },
        {
          label: "wifi",
          value: "2"
        }
      ],
      //   内外勤--下拉：
      isInsides: [
        {
          label: "内勤",
          value: "1"
        },
        {
          label: "外勤",
          value: "2"
        }
      ],
      detailData: ""
    };
  },
  components: {
    Detail
  },
  methods: {
    //头部样式
    getRowClass({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color: #f5f7fa;color:#000;width:100%;text-aligin:center;text-align: center;";
      } else {
        return "";
      }
    },
    //分页
    handleCurrentChange: function(currentPage) {
      this.currentPage = currentPage;
      this.getClock();
    },
    //分页：
    handleSizeChange: function(size) {
      this.pagesize = size;
      this.getClock();
    },
    //分页
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    //打卡列表
    getClock() {
      var createDateStarts;
      if (
        this.searchData.createDateStart == "" ||
        this.searchData.createDateStart == null
      ) {
        createDateStarts = "";
      } else {
        createDateStarts = this.formatDateTime(this.searchData.createDateStart);
      }
      var createDateEnds;
      if (
        this.searchData.createDateEnd == "" ||
        this.searchData.createDateEnd == null
      ) {
        createDateEnds = "";
      } else {
        createDateEnds = this.formatDateTime(this.searchData.createDateEnd);
      }
      this.postAxios("/record/list", {
        pageNum: this.currentPage,
        pageSize: 10,
        userInfoId: this.searchData.userInfoId, //用户 id
        createDateStart: createDateStarts, //打卡时间-起始
        createDateEnd: createDateEnds, //打卡时间-结束
        isInside: this.searchData.isInside, //内外勤
        recordType: this.searchData.recordType //打卡类型
      }).then(res => {
        if (res.success == true) {
          this.clockList = res.content;
          this.totalCount = res.totalCount;
        } else if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push("/");
        } else if (res.success == false) {
          this.$message.error(res.message);
        }
      });
    },
    addZero(num) {
      return num < 10 ? "0" + num : num;
    },
    formatDateTime(date) {
      const time = new Date(Date.parse(date));
      //   time.setTime(time.setHours(time.getHours() + 8));
      const Y = time.getFullYear() + "-";
      const M = this.addZero(time.getMonth() + 1) + "-";
      const D = this.addZero(time.getDate()) + " ";
      const h = this.addZero(time.getHours()) + ":";
      const m = this.addZero(time.getMinutes()) + ":";
      const s = this.addZero(time.getSeconds());
      // const s = this.addZero(time.getSeconds());
      return Y + M + D + h + m + s;
    },
    clockClear() {
      // this.$refs.ruleForm.resetFields();

      (this.searchData.userInfoId = ""), //用户 id
        (this.searchData.createDateStart = ""), //打卡时间-起始
        (this.searchData.createDateEnd = ""), //打卡时间-结束
        (this.searchData.isInside = ""), //内外勤
        (this.searchData.recordType = ""); //打卡类型
    },
    //打卡查询：
    clockSearch() {
      //打卡时间-开始
      var createDateStarts;
      if (
        this.searchData.createDateStart == "" ||
        this.searchData.createDateStart == null
      ) {
        createDateStarts = "";
      } else {
        createDateStarts = this.formatDateTime(this.searchData.createDateStart);
      }
      var createDateEnds;
      if (
        this.searchData.createDateEnd == "" ||
        this.searchData.createDateEnd == null
      ) {
        createDateEnds = "";
      } else {
        createDateEnds = this.formatDateTime(this.searchData.createDateEnd);
      }

      this.currentPage = 1;
      this.postAxios("/record/list", {
        pageNum: this.currentPage,
        pageSize: 10,
        userInfoId: this.searchData.userInfoId, //用户 id
        createDateStart: createDateStarts, //打卡时间-起始
        createDateEnd: createDateEnds, //打卡时间-结束
        isInside: this.searchData.isInside, //内外勤
        recordType: this.searchData.recordType //打卡类型
      }).then(res => {
        if (res.success == true) {
          this.clockList = res.content;
          this.totalCount = res.totalCount;
        } else if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push("/");
        } else if (res.success == false) {
          this.$message.error(res.message);
        }
      });
    },
    //打卡下载：
    clockLoad() {
      //下载路劲**************
      axios({
        method: "post",
        serverUrl: baseURL + "/file/uploadFile",
        data: {
          userInfoId: this.userInfoIds //用户 id
        }, // 参数
        responseType: "blob" // 表明返回服务器返回的数据类型
      })
        .then(response => {
          this.download(response);
        })
        .catch(error => {});
    },
    // 下载文件
    download(data) {
      if (!data) {
        return;
      }
      let url = window.URL.createObjectURL(new Blob([data]));
      let link = document.createElement("a");
      link.style.display = "none";
      link.href = url;
      link.setAttribute("download", "excel.xlsx");

      document.body.appendChild(link);
      link.click();
    },
    // 获取用户
    getUserInfo() {
      this.getAxios("/record/list/user", {}).then(res => {
        if (res.success == true) {
          this.userInfo = res.content;
        } else if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push("/");
        } else if (res.success == false) {
          this.$message.error(res.message);
        }
      });
    },
    //选择查询用户
    userChange(id) {
      this.userInfoIds = id;
    },
    //取消删除弹框
    handleCancel() {
      this.delOpen = false;
    },
    //删除弹框确认
    handleOk() {
      this.getAxios("/record/delete", {
        id: this.delId
      }).then(res => {
        if (res.success == true) {
          this.$message.success("删除成功！");
          this.delOpen = false;
          this.getClock(); //列表
        } else if (res.success == false) {
          this.$message.error(res.message);
        } else if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push("/");
        }
      });
    },
    // 打卡列表删除
    clockDel(id) {
      this.delId = id;
      this.delOpen = true;
    },

    //打卡详情：
    clockDetail(row) {
      this.detailData = row; //数据
      this.visible = true;
    },
    onClose() {
      this.visible = false;
    },
    detailCancel() {
      this.detailOpen = false;
    }
  },
  created() {
    this.getClock(); //打卡列表
    this.getUserInfo(); //用户数据
  },
  mounted() {}
};
</script>
<style scoped lang="less">
.clock {
  width: 100%;
  height: 100%;
  .clock_box {
    width: 95%;
    height: auto;
    margin: 20px auto;
    .el-card {
      margin-top: 15px;
      .done {
        margin-left: 50px;
        display: flex;
        // flex-direction: column;

        // background: red;
        //  text-align: center;

        // .dels {
        //   width: 50px;
        //   text-align: center;
        // }
        //表格操作按钮
        /deep/ .el-button--primary {
          color: #fff;
          background-color: #409eff;
          border-color: #409eff;
          width: 100px;
          margin-top: 10px;
          margin-left: 10px;
          height: 30px;
          line-height: 5px;
          font-size: 12px;
        }
      }
      //按钮样式
      /deep/ .el-button--primary {
        color: #fff;
        background-color: #409eff;
        border-color: #409eff;
        width: 100px;
      }
    }

  }
}
</style>